import { Button } from "PFComponents/button";
import React from "react";
import { useTranslation } from "react-i18next";

import { ManageReportsSidePanel } from "./side_panel/manage_reports_side_panel";
import { useManageReports } from "./use_manage_reports";

const ManageReports = (): JSX.Element => {
  const { t } = useTranslation("bookingModule");
  const { showManageReports, handleOpenManageReports, handleCloseManageReports } = useManageReports();

  return (
    <>
      <Button onClick={handleOpenManageReports} kind="tertiary">
        {t("reports.manageReports.title")}
      </Button>
      <ManageReportsSidePanel show={showManageReports} onClose={handleCloseManageReports} />
    </>
  );
};

export default ManageReports;
